import React, { useEffect, useState } from 'react';
import { render } from 'react-dom';
import { loadStripe, PaymentRequestOptions, PaymentRequest, CanMakePaymentResult } from '@stripe/stripe-js';
import { PaymentRequestButtonElement, useStripe, } from '@stripe/react-stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import styles from './DigitalWalletButton.scss';

interface CheckoutFormProps {
    charityKey: string;
}


const CheckoutForm = ({ charityKey }: CheckoutFormProps) => {
    const stripe = useStripe();
    const [stripePaymentRequest, setStripePaymentRequest] = useState<PaymentRequest | null>(null);
    const [stripePaymentAvailability, setstripePaymentAvailability] = useState<CanMakePaymentResult | null>(null);
    const [isDisabled, setIsDisabled] = useState(true);
    const [isHidden, setIsHidden] = useState(false);

    const handleclick = () => {
        const inputFields = document.querySelectorAll('#donate-form-fields input, #donate-form-fields select, #donate-form-fields textarea');
        const fields: { [key in string]: string | undefined } = {};

        const createPaymentIntent = async (amount: number, email: string, firstName: string, lastName: string, appealTitle: string, paymentMethod: string) => {
            const data = amount ? await fetch('/api/stripe/paymentintent/', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    amount: amount,
                    charityKey: charityKey,
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    appealTitle: appealTitle,
                    paymentMethod: paymentMethod
                })
            })
            .then(response => response.json())
            .then(async (result) => {
                const clientSecret = result.paymentintent.client_secret;
                const givingId = result.givingid
                fields["givingid"] = givingId;
                const compounduuid = await tagsRes(fields);
                const customerId = result.customerid;
                const paymentIntentId = result.paymentintent.id
                console.log('PaymentIntentId: ' + paymentIntentId);

                if ((stripePaymentRequest as any).hasRegisteredListener('paymentmethod')) {
                    stripePaymentRequest?.off('paymentmethod');
                };

                stripePaymentRequest?.on('paymentmethod', async (ev) => {
                    // Confirm the PaymentIntent without handling potential next actions (yet).
                    const { paymentIntent, error: confirmError } = await stripe!.confirmCardPayment(
                        clientSecret,
                        { payment_method: ev.paymentMethod.id },
                        { handleActions: false }
                    );

                    if (confirmError) {
                        // Report to the browser that the payment failed, prompting it to
                        // re-show the payment interface, or show an error message and close
                        // the payment interface.
                        ev.complete('fail');
                        console.log('Payment failed ' + confirmError);
                        //alert('Payment failed ' + confirmError)
                    } else {
                        // Report to the browser that the confirmation was successful, prompting
                        // it to close the browser payment method collection interface.

                        // Check if the PaymentIntent requires any actions and if so let Stripe.js
                        // handle the flow. If using an API version older than "2019-02-11"
                        // instead check for: `paymentIntent.status === "requires_source_action"`.
                        if (paymentIntent?.status === "requires_action") {
                            // Let Stripe.js handle the rest of the payment flow.
                            console.log('Payment failed, futher action required');
                            const { error } = await stripe!.confirmCardPayment(clientSecret);
                            if (error) {
                                console.log('Payment failed:' + error);
                                // The payment failed -- ask your customer for a new payment method.
                                console.log('The payment failed -- ask your customer for a new payment method.');
                            } else {
                                // The payment has succeeded.
                                console.log('Payment successful after required action');
                            }
                        } else {
                            // The payment has succeeded.
                            console.log('Payment successful complete payment');
                            //await completePayment(customerId, paymentIntentId)
                            //await finalizePayment(givingId, compounduuid);
                            ev.complete('success');
                            await redirectAndComplete(customerId, paymentIntentId, givingId, compounduuid);
                            console.log('Process successful, closing payment method collection interface');
                        }
                    }
                });
            }) : null;
        }

        const tagsRes = (fields: { [key in string]: string | undefined }): Promise<any> => {
            return fetch(`/odata/v1.0/records?charityKey=${charityKey}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify(fields),
            })
            .then(response => response.json())
            .then(result => {
                console.log('TagRes result = ' + result);
                console.log('compounduuid: ' + result.compounduuid)
                return result.compounduuid;
            });
        }

        const mapValues = (elementField: Element) => {
            const field = elementField as HTMLInputElement;
            let { name } = field;
            let inputValue = '';

            switch (field.nodeName.toLowerCase()) {
                case 'textarea':
                    // Special case for comment/message on form
                    if (name === 'message') {
                        name = 'comment_message'; // urgh - must be legacy logic
                    }
                    inputValue = field.value;
                    break;
                case 'input':
                    // Special case for amount with matched multiplier
                    if (name === 'amount' && field.hasAttribute('data-multiplier')) {
                        fields.multiplier = field.attributes.getNamedItem('data-multiplier')?.value;
                    }
                    inputValue = field.value;
                    break;
                case 'select':
                    const selectField = elementField as HTMLSelectElement;
                    inputValue = selectField.options[selectField.selectedIndex].text;
                    break;
                default:
                    break;
            }

            fields[name] = inputValue;
        };

        const completePayment = async (customerId: string, paymentIntentId: string) => {
            await fetch(`/api/CompleteStripeWalletGivings?customerId=${customerId}&paymentIntentId=${paymentIntentId}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'GET',
                credentials: 'include'
            })
                .then(response => response.status)
                .then(result => {
                    console.log('completePayment result = ' + result);
                })
                .catch(error => {
                    // Error is caught and logged here. You can remove the logging if you prefer to swallow the error silently.
                    console.error('Error in completePayment:', error);
                });
        }

        const finalizePayment = async (givingId: number, compounduuid: string) => {
            await fetch(`/api/givings/${givingId}/finalize`, {
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'PUT',
                credentials: 'include',
                body: JSON.stringify({
                    compounduuid: compounduuid,
                })
            })
            .then(response => response.json())
            .then(result => {
                console.log('finalizePayment result = ' + result);
                window.location.assign('/Services/StripeWallet/Redirect?thankYouUrl=' + result.thankYouUrl);
            });
        }

        const redirectAndComplete = async (customerId: string, paymentIntentId: string, givingId: number, compounduuid: string) => {
            window.location.assign('/Services/StripeWallet/Complete?customerId=' + customerId + '&paymentIntentId=' + paymentIntentId + '&givingId=' + givingId + '&compoundUuid=' + compounduuid);
        };

        // Map all input elements
        inputFields.forEach((field) => mapValues(field as HTMLInputElement));

        const amount = parseFloat(fields['amount'] as string);

        if (stripePaymentRequest && stripePaymentAvailability) {
            const paymentMethod = stripePaymentAvailability.applePay ? "ApplePay"
                : stripePaymentAvailability.googlePay ? "GooglePay"
                    : null
            createPaymentIntent(amount, fields['email'] as string, fields['firstname'] as string, fields['lastname'] as string, fields['appealtitle'] as string, paymentMethod as string)

            stripePaymentRequest.update({
                total: {
                    label: "Total",
                    amount: amount * 100,
                }
            })
        }
    }

    useEffect(() => {

        if (stripe) {
            if (stripePaymentRequest === null) {
                const paymentRequest = {
                    country: 'AU',
                    currency: 'aud',
                    total: {
                        label: 'Total',
                        amount: 0,
                    },
                    requestPayerName: true,
                    requestPayerEmail: true,
                    disableWallets: ['link'],

                } as PaymentRequestOptions;

                // Check the availability of the Payment Request API.
                const request = stripe.paymentRequest(paymentRequest);
                request.canMakePayment().then(result => {
                    if (result !== null) {
                        setstripePaymentAvailability(result)
                        setStripePaymentRequest(request);
                    }
                });
            }
        }
    }, [stripe]);

    useEffect(() => {
        // the greatest hacks known to man
        // is possible the form is pre-filled so let's handle that here
        setIsDisabled(Boolean(document.querySelector('#donate-form-actions a')?.attributes.getNamedItem('disabled')));
        const donateButtonObserver = new MutationObserver((mutations) => {
            // we set a data-disabled attribute on the paypalbutton container to know if these buttons are disabled or not
            if (mutations[0].attributeName !== 'data-disabled') {
                return;
            }

            setIsDisabled(!(mutations[0]?.oldValue === 'true'));
        });

        // use paypal-button-container here as it's essentially checking the same thing
        donateButtonObserver.observe(document.querySelector('#paypal-button-container')!, { attributeOldValue: true });

        // handle recurring givings
        // we get the label here because that's the only thing that changes on select
        const onceOffRadio = document.querySelector('#donate-form-fields label[for=giving_frequency_1]');

        // once-off does not exist, hide button
        if (!onceOffRadio) {
            setIsHidden(true);

            return;
        }

        // disable paypal button when we don't have once off selected
        const onceOffObserver = new MutationObserver((mutations) => {
            const target = mutations[0].target as HTMLElement;
            const onceOffValue = target.attributes.getNamedItem('class')?.value;

            setIsHidden(onceOffValue !== 'selected');
        });

        onceOffObserver.observe(onceOffRadio, { attributes: true });

        //  handle mobile since it's a different input
        document.querySelector('#donate-form-fields select[name=giving_frequency]')?.addEventListener('change', (e) => {
            const target = e.target as HTMLSelectElement;
            setIsHidden(target.value !== '1');
        });
    }, []);

    if (stripePaymentRequest && !isHidden) {
        return (
            <div className={styles['digital-wallet-button']}>
                <PaymentRequestButtonElement
                    options={{
                        paymentRequest: stripePaymentRequest,
                        style: {
                            paymentRequestButton: {
                                type: 'donate',
                                // One of 'default', 'book', 'buy', or 'donate'
                                // Defaults to 'default'

                                theme: 'dark',
                                // One of 'dark', 'light', or 'light-outline'
                                // Defaults to 'dark'

                                height: '54px',
                                // Defaults to '40px'. The width is always '100%'.
                            },
                        }
                    }}
                    onClick={(e: { preventDefault: () => void; }): void => {
                        if (isDisabled) {
                            e.preventDefault();

                            return;
                        }

                        handleclick();
                    }}
                />
            </div>
        );
    }

    // Use a traditional checkout form.
    return null;
}


const DigitalWalletButton = ({ charityKey }: DigitalWalletProps) => {
    const stripePublishableKey = (document.getElementById('hfStripePublishableKey') as HTMLInputElement)?.value;
    const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;

    return stripePromise ? (
        <Elements stripe={stripePromise}>
            <CheckoutForm charityKey={charityKey} />
        </Elements>
    ) : null;
}

interface DigitalWalletProps {
    charityKey: string;
}

interface DigitalWalletButtonAppProps {
    charitykey: string;
    isteampage: boolean;
}

// render button under the other Donate button in the donation form
const DigitalWalletButtonApp = function DigitalWalletButtonApp({ charitykey, isteampage }: DigitalWalletButtonAppProps) {
    console.log(charitykey);

    const renderDigitalWalletButton = () => {
        render(<DigitalWalletButton charityKey={charitykey} />, document.querySelector('#digitalwallet-button-container'));
    };

    useEffect(() => {
        if (isteampage) {
            // need the timeout here as I'm not sure what's causing the page to rerender
            setTimeout(renderDigitalWalletButton, 100);
        } else {
            renderDigitalWalletButton();
        }
    }, []);

    return null;
};

export default DigitalWalletButtonApp;
